import { APP_BASE_URL } from "../AppConstant";

const BASE = `${APP_BASE_URL}/timetracker`;

async function request(path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method: body ? "POST" : "GET",
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || `Request failed (${res.status})`);
  return data;
}

export const api = {
  getProjects: () => request("/getprojects"),
  getMonthHours: (empid, month) => request("/getmonthhours", { empid, month }),
  getTimeEntry: (empid, dateofentry) => request("/gettimeentry", { empid, dateofentry }),
  addTimeEntry: (body) => request("/addtimeentry", body),
  deleteTimeEntry: (empid, id) => request("/deletetimeentry", { empid, id }),
  // Employees whose reporting manager email in the user master is `email`.
  getReportees: (email) => request("/getreportees", { email }),
  getPendingEntries: (email, empid) => request("/getpendingentries", { email, empid }),
  // action: "accept" | "reject"
  reviewTimeEntries: (email, empid, ids, action) => request("/reviewtimeentries", { email, empid, ids, action }),

  // month "YYYY-MM" for one month, omit for all holidays.
  getHolidays: (month) => request("/getholidays", month ? { month } : {}),
  // Admin only: `email` is the logged-in user's, checked against the backend's ADMIN_EMAILS.
  addHoliday: (email, date, name) => request("/addholiday", { email, date, name }),
  updateHoliday: (email, id, date, name) => request("/updateholiday", { email, id, date, name }),
  deleteHoliday: (email, id) => request("/deleteholiday", { email, id }),
  addProject: (email, name) => request("/addproject", { email, name }),
  updateProject: (email, id, name) => request("/updateproject", { email, id, name }),
  deleteProject: (email, id) => request("/deleteproject", { email, id }),
  // filterby: "department" | "project" | "manager"; returns [{ value, label }] for the second dropdown.
  getDownloadFilters: (email, fromdate, todate, filterby) =>
    request("/getdownloadfilters", { email, fromdate, todate, filterby }),
  getDownloadEntries: (email, fromdate, todate, filterby, filtervalue) =>
    request("/getdownloadentries", { email, fromdate, todate, filterby, filtervalue }),
};

// Users who see the Holidays and Projects tabs (the backend has the same list).
export const ADMIN_EMAILS = ["bcs_sridevi@switchmobilityev.com"];
